<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Edit Elomark User</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>First Name:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="first_name"
                v-model="elomarkUserDescription.first_name"
                v-validate="'required'"
                data-vv-as="First Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('first_name')"
              >{{ errors.first("first_name") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="surname"
                v-model="elomarkUserDescription.surname"
                v-validate="'required'"
                data-vv-as="Surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first("surname") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Job Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="job_role"
                v-model="elomarkUserDescription.job_role"
                data-vv-as="Job Role"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('job_role')"
              >{{ errors.first("job_role") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Desk Phone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="desk_phone"
                v-model="elomarkUserDescription.desk_phone"
                data-vv-as="Desk Phone"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('desk_phone')"
              >{{ errors.first("desk_phone") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Softphone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="softphone"
                v-model="elomarkUserDescription.softphone"
                data-vv-as="Softphone"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('softphone')"
              >{{ errors.first("softphone") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Mobile No.:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="mobile_no"
                v-model="elomarkUserDescription.mobile_no"
                data-vv-as="Mobile No."
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('mobile_no')"
              >{{ errors.first("mobile_no") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Alternate Phone 1:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_1"
                v-model="elomarkUserDescription.alternate_phone_1"
                data-vv-as="Alternate Phone 1"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_1')"
              >{{ errors.first("alternate_phone_1") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Alternate Phone 2:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_2"
                v-model="elomarkUserDescription.alternate_phone_2"
                data-vv-as="Alternate Phone 2"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_2')"
              >{{ errors.first("alternate_phone_2") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>User Status:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">

              <!-- <select name="user_status" v-validate="'required'" v-model="elomarkUserDescription.selected_user_status" class="w-full v-select-box p-2">
                <option v-for="item in userStatusList" :value="item">{{ item.user_status }}
                </option>
              </select> -->

              <v-select
                v-validate="'required'"
                required
                label="user_status"
                name="selected_user_status"
                :options="userStatusList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="elomarkUserDescription.selected_user_status"
                data-vv-as="User Status"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('selected_user_status')"
              >{{ errors.first("selected_user_status") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">

              <!-- <select name="role" v-validate="'required'" v-model="elomarkUserDescription.role" class="w-full v-select-box p-2">
                <option v-for="item in elomarkRoleTypes" :value="item">{{ item.role }}
                </option>
              </select> -->


              <v-select ref="changeRole" @input="changeRole(elomarkUserDescription.role)"
                v-validate="'required'"
                required
                name="role"
                label="role"
                :options="elomarkRoleTypes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="elomarkUserDescription.role"
                data-vv-as="User Role"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('role')"
              >{{ errors.first("role") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Manager:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select ref="changeManager" @input="changeManager(elomarkUserDescription.selected_manager)"
                label="full_name"
                :options="elomarkManagers"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="elomarkUserDescription.selected_manager"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address 1:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="address_1"
                v-model="elomarkUserDescription.address_1"
                data-vv-as="Address 1"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('address_1')"
              >{{ errors.first("address_1") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address 2:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="address_2"
                v-model="elomarkUserDescription.address_2"
                data-vv-as="Address 2"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address 3:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="address_3"
                v-model="elomarkUserDescription.address_3"
                data-vv-as="Address 3"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="city"
                v-model="elomarkUserDescription.city"
                data-vv-as="City"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('city')"
              >{{ errors.first("city") }}</span
            >
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="county"
                v-model="elomarkUserDescription.county"
                data-vv-as="County"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('county')"
              >{{ errors.first("county") }}</span
            >
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mr-10">
              <AccountAutocomplete
                class="searchbox"
                :list="getCountries"
                :searchOn="'head_office_country'"
              ></AccountAutocomplete>
            </div>
            {{ countryName }}
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="postcode"
                v-model="elomarkUserDescription.postcode"
                data-vv-as="postcode"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('postcode')"
              >{{ errors.first("postcode") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Rate:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="rate"
                v-model="elomarkUserDescription.rate"
                data-vv-as="rate"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('rate')"
              >{{ errors.first("rate") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Date Of Birth:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <flat-pickr
                class="flat-pick"
                name="dob"
                :config="configdateTimePicker"
                v-model="elomarkUserDescription.dob"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('dob')"
              >{{ errors.first("dob") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Contract Start Date:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <flat-pickr
                class="flat-pick"
                name="contract_commencement_date"
                :config="configdateTimePicker"
                v-model="elomarkUserDescription.contract_commencement_date"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('contract_commencement_date')"
              >{{ errors.first("contract_commencement_date") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Timezone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <TimezoneAutocomplete
                class="searchbox mb-5"
                :list="getTimezones"
                :searchOn="'timezone'"
                @event-name="handleTimeZoneSelected"
              ></TimezoneAutocomplete>
              {{ timeZoneName }}
            </div>

            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('timezone')"
              >{{ errors.first("timezone") }}</span
            >
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>User Type:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select
                name="user_type"
                label="usertype"
                :options="allUserTypes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="elomarkUserDescription.user_type"
                v-validate="'required'"
                data-vv-as="User Type"
              />
              <div
                class="mt-5"
                v-if="
                  elomarkUserDescription.isContractor == 'y' ||
                    elomarkUserDescription.company_id
                "
              >
                <span>Is associated with company?</span>
                <vs-switch
                  class="mt-3"
                  vs-icon-on="check_box"
                  vs-icon-off="block"
                  v-model="elomarkUserDescription.hasCompanyId"
                  vs-value="true"
                >
                  <span slot="on">YES</span>
                  <span slot="off">NO</span>
                </vs-switch>
              </div>
            </div>

            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('user_type')"
              >{{ errors.first("user_type") }}</span
            >
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <template
              v-if="
                elomarkUserDescription.hasCompanyId ||
                  elomarkUserDescription.company_id
              "
            >
              <div class="vx-col sm:w-1/6 w-full">
                <span>Company:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <AccountAutocomplete
                  :key="companySearchComponentKey"
                  class="searchbox mb-5"
                  :list="searchAccount"
                  :searchOn="'company_or_registration_no'"
                  @event-name="handleChildEvent"
                ></AccountAutocomplete>
                {{ companyName }}
              </div>
            </template>
          </vs-col>
          <template
            v-for="(language, index) in elomarkUserDescription.languages"
          >
            <vs-col vs-type="flex" vs-w="6" class="mb-6" :key="index">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Language:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <LanguageAutocomplete
                  class="searchbox"
                  :list="getLanguages"
                  :searchOn="'language'"
                  @event-name="handleLanguageSelected(index)"
                ></LanguageAutocomplete>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  ><span class="p-2">{{ language.languages_name }}</span>
                </vs-col>
              </div>
              <div class="vx-col sm:w-1/3 w-full ml-2">
                <v-select
                  name="language_compentency"
                  label="name"
                  :options="languageCompetency"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="language.language_competency_name"
                  data-vv-as="User Compentency"
                />
              </div>
              <feather-icon
                class="ml-5"
                icon="XIcon"
                svgClasses="h-4 w-4"
                v-on:click="removeLanguage(index)"
              />
            </vs-col>
          </template>
          <vs-col vs-type="flex" vs-w="12" class="mb-6">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-button
                class="mt-5 mb-5"
                color="danger"
                @click="selectAnotherLanguage()"
                >Add More language</vs-button
              >
            </vs-col>
          </vs-col>

          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Login Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Email Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="elomarkUserDescription.email"
                name="email"
                v-validate="'email|required'"
                data-vv-as="Email Address"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('email')"
              >{{ errors.first("email") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Reset Password:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox
                v-model="check_box_selected"
                :vs-value="1"
              ></vs-checkbox>
            </div>
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import TimezoneAutocomplete from "@/components/autocomplete/TimezoneAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import moduleUserTypeManagement from "@/store/usertype-management/moduleUserTypeManagement.js";
import LanguageAutocomplete from "@/components/autocomplete/LanguageAutocomplete.vue";
import vSelect from "vue-select";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      counter: 0,
      languageCompetency: [],

      abilities: null,
      timeZoneName: null,
      companyName: null,
      countryName: null,
      allUserTypes: [],
      allTimezones: [],
      companySearchComponentKey: 0,
      elomarkUserId: null,
      elomarkManagers: [],
      elomarkRoleTypes: [],
      userStatusList: [],
      check_box_selected: null,
      elomarkUserDescription: {
        languages: [
          {
            language_id: null,
            language_compentency: null,
            id: 0
          }
        ],
        isContractor: "n",
        first_name: null,
        surname: null,
        desk_phone: null,
        softphone: null,
        mobile_no: null,
        alternate_phone_1: null,
        alternate_phone_2: null,
        job_role: null,
        email: null,
        role: null,
        address_1: null,
        address_2: null,
        address_3: null,
        country: null,
        postcode: null,
        timezone: null,
        county: null,
        city: null,
        user_type: null,
        company_id: null,
        password_reset: null
      },
      configdateTimePicker: {
        enableTime: false,
        // dateFormat: "Y-m-d",
        format: "d/m/Y",
        altFormat: "d/m/Y",
        altInput: true
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleElomarkUserManagement,
    ElomarkUserAutocomplete,
    AccountAutocomplete,
    TimezoneAutocomplete,
    flatPickr,
    LanguageAutocomplete
  },
  watch: {
    "elomarkUserDescription.user_type"(val) {
      if (val) {
        if (val.usertype == "Contractor") {
          this.elomarkUserDescription.isContractor = "y";
        } else {
          this.elomarkUserDescription.isContractor = "n";
          this.elomarkUserDescription.hasCompanyId = false;
        }
      }
    }
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleUserTypeManagement.isRegistered) {
      this.$store.registerModule(
        "usertypesManagement",
        moduleUserTypeManagement
      );
      moduleUserTypeManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }

    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  },
  beforeMount() {
    this.getElomarkManagers();
    this.getElomarkRoleTypes();
    this.getElomarkUserStatus();
    this.getUserTypes();
    this.getLanguageCompetency();

  },
  mounted() {
   
    this.elomarkUserId = this.$route.params.userId;
    this.init();
  },
  methods: {
    changeRole(selectObj) {

      let self = this;

      self.$nextTick(() => {

        self.$refs.changeRole.value = selectObj

      
      });

      
       
     },
     changeManager(selectObj) {

let self = this;

self.$nextTick(() => {

  self.$refs.changeManager.value = selectObj


});


 
},
    getTimezones(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/getTimezones", inputValue)
        .then(response => {
          let data = moduleElomarkUserManagement.state.all_time_zone;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].label
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    handleLanguageSelected(index) {
      var selected_language =
        moduleElomarkUserManagement.state.selected_language;
      this.elomarkUserDescription.languages[index]["language_id"] =
        selected_language.id;
    },
    getLanguages(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/getAllLanguages", inputValue)
        .then(response => {
          let data = moduleElomarkUserManagement.state.all_languages;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    removeLanguage(index) {
      this.elomarkUserDescription.languages.splice(index, 1);
    },
    getLanguageCompetency() {
      this.$store
        .dispatch("elomarkUsersManagement/fetchAllLanguageCompetency")
        .then(res => {
          this.languageCompetency = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    selectAnotherLanguage() {
      this.elomarkUserDescription.languages.push({
        id: ++this.counter,
        language_id: null,
        language_compentency: null
      });
      this.counter++;
    },
    getUserTypes() {
      this.$store
        .dispatch("usertypesManagement/fetchAllTypes")
        .then(res => {
          this.allUserTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    showCompanyName(accountId) {
      this.$store
        .dispatch("accountsManagement/fetchAccount", accountId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.companyName = response.company_name;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleTimeZoneSelected() {
      var selected_time_zone =
        moduleElomarkUserManagement.state.selected_time_zone;
      this.elomarkUserDescription.timezone = selected_time_zone.id;
    },
    handleChildEvent() {
      var selected_account = moduleAccountsManagement.state.accounts.datas;
      this.elomarkUserDescription.company_id = selected_account[0].id;
    },
    init() {
      this.$store
        .dispatch("elomarkUsersManagement/fetchElomarkUser", this.elomarkUserId)
        .then(res => {
          if(res.data){
          var self = this;
          self.elomarkUserDescription = res.data;

           
          if(self.elomarkRoleTypes.length == 0){
            self.getElomarkRoleTypes()
            self.init()
          }

          if(self.userStatusList.length == 0){
            self.getElomarkUserStatus()
            self.init()
          }

          if(self.elomarkManagers.length == 0){
            self.getElomarkManagers()
            self.init()
          }

          if(self.allUserTypes.length == 0){
            self.getUserTypes()
            self.init()
          }

          self.elomarkRoleTypes.forEach(function(ele) {
            if (ele.id == self.elomarkUserDescription.user_role) {
              self.elomarkUserDescription.role = ele;
            }
          });

          self.userStatusList.forEach(function(ele) {
            if (ele.id == self.elomarkUserDescription.user_status) {
              self.elomarkUserDescription.selected_user_status = ele;
            }
          });

        

          self.elomarkManagers.forEach(function(ele) {
            if (ele.id == self.elomarkUserDescription.manager) {
              self.elomarkUserDescription.selected_manager =
                ele.first_name + " " + ele.surname;
            }
          });

          self.allUserTypes.forEach(function(ele) {
            if (ele.id == self.elomarkUserDescription.user_type) {
              self.elomarkUserDescription.user_type = ele;
            }
          });

          if (self.elomarkUserDescription.timezone) {
            this.showTimeZoneName(this.elomarkUserDescription.timezone);
          }

          if (self.elomarkUserDescription.country) {
            this.showCountryName(this.elomarkUserDescription.country);
          }
          if (this.elomarkUserDescription.company_id) {
            this.showCompanyName(this.elomarkUserDescription.company_id);
          }
          }
          
        })
        .catch(err => {
          console.error(err);
        });
    },
    getElomarkUserStatus() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkUserStatus")
        .then(res => {
          this.userStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    showCountryName(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.countryName = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    showTimeZoneName(timezoneId) {
      this.$store
        .dispatch("elomarkUsersManagement/getTimeZone", timezoneId)
        .then(res => {
          this.timeZoneName = res.data.label;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.timeZoneName = true;
            return;
          }
          console.error(err);
        });
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.elomarkUserDescription.languages.forEach(element => {
        if (element.languages_uuid) {
          element.language_id = element.languages_uuid;
          element.language_competency_id = element.language_competency_uuid;
        } else {
          element.language_competency_id = element.language_competency_name.id;
        }
      });


        if (moduleAccountsManagement.head_office_country_selected) {
          this.elomarkUserDescription.country =
            moduleAccountsManagement.head_office_country_selected.id;
        } 

      // console.log(this.elomarkUserDescription.languages)
      // return false

      if (this.check_box_selected) {
        this.elomarkUserDescription.password_reset = "y";
      } else {
        this.elomarkUserDescription.password_reset = "n";
      }

      if (typeof this.elomarkUserDescription.timezone === "object") {
        this.elomarkUserDescription.timezone = this.elomarkUserDescription.timezone.id;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.elomarkUserDescription.selected_role = this.elomarkUserDescription.role;
          this.updateElomarkUser();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    updateElomarkUser() {


      this.$vs.loading();

      this.$store
        .dispatch(
          "elomarkUsersManagement/updateElomarkUser",
          this.elomarkUserDescription
        )
        .then(res => {
          let self = this
          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Elomark User Updated",
              text: "The user was updated successfully"
            });
            self.$router.push({ path: "/elomark-users" });
          }
          else{
            self.$vs.notify({
              color: "danger",
              title: "Client User",
              text: "Email Already Exists"
            });
            setTimeout(()=> { self.$router.go(0) }, 2000);

          }
          this.$vs.loading.close();
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getElomarkRoleTypes() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkRoleTypes")
        .then(res => {
          this.elomarkRoleTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getElomarkManagers() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkManagers")
        .then(res => {
          this.elomarkManagers = res.data;
          this.elomarkManagers = this.elomarkManagers.filter(function(ele) {
            ele.full_name = ele.first_name + " " + ele.surname;
            return ele;
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style>
.flat-pick {
  padding: 0.7rem;
  font-size: 1rem;
  color: #626262;
  cursor: pointer;
}

.v-select-box {
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
